import {
  Link,
  Droppable,
  FilterManager,
  Separator,
  Board,
  CheckBox,
  ActionButton,
  DropDown,
  InputGroup,
  SelectionComponent,
  PageHeader,
  Balloon,
  MultiCheckBox,
  Callout,
} from './../components';

//only import shared components like dropdown, select,... NO VIEWS
const components = {
  Link,
  Droppable,
  FilterManager,
  Separator,
  Board,
  CheckBox,
  ActionButton,
  DropDown,
  InputGroup,
  SelectionComponent,
  PageHeader,
  Balloon,
  MultiCheckBox,
  Callout,
};

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => {
      Vue.component(name, components[name]);
    });
  },
};
